module.exports = __webpack_public_path__ + "static/UI pattern - navigation 1-32f98acfbc3ce6160e860570050b6e9c.png";